export function isClientErrorStatus(status) {
  return typeof status === 'number' && status >= 400 && status < 500
}

export function storeAppLogin({ login, password, mode }) {
  if (typeof window === 'undefined' || typeof window.sendToWebView !== 'function') return
  window.sendToWebView('login', {
    login,
    password,
    mode,
    id: Date.now().toString(36),
  })
}

export function clearStoredFingerprint() {
  if (typeof window === 'undefined' || typeof window.sendToWebView !== 'function') return
  window.sendToWebView('delete_credentials', {})
  window.sendToWebView('set_login_mode', { mode: null })
}
